import React from 'react';
import { AnimatedLetter } from '../../utils/customStyles';
import { AnimatedWords } from './animateStyle';

const Animated = ({ letterClass, strArray, idx }) => {
  return (
    <AnimatedWords>
      {strArray.map((char, i) => (
        <AnimatedLetter
          key={char + i}
          letterClass={letterClass}
          aria-hidden='true'
          delayCount={i + idx}
        >
          {char}
        </AnimatedLetter>
      ))}
    </AnimatedWords>
  );
};

export default Animated;
